export enum AccessStatusType {
  Open = 'Open',
  Locked = 'Locked',
}

export enum ModalType {
  AssociatedData = 'AssociatedData',
  MultipleLinkedItems = 'MultipleLinkedItems'
}
